// ==========================================
// PROCEDURE CATEGORY CONFIGURATION
// ==========================================
// UI metadata and utilities for procedure categories.

import { ProcedureCategory, ProcedureCategoryInfo } from '../ontology.model';

export const PROCEDURE_CATEGORIES: ProcedureCategoryInfo[] = [
  {
    name: ProcedureCategory.Transformation,
    description: 'Same value, different form',
    topics: 'Real → Standard Form, Expand Brackets',
    example: '$34500 \\to 3.45 \\times 10^4$',
    color: '#ede9fe',
  },
  {
    name: ProcedureCategory.Calculation,
    description: 'Calculate a concrete result',
    topics: 'f(3) → 7, Calculate N-th Term',
    example: '$u_n = ar^{n-1} \\Rightarrow u_{10} = 0.00586$',
    color: '#d1fae5',
  },
  {
    name: ProcedureCategory.Operation,
    description: 'Combine entities using an abstract operation',
    topics: 'Add Fractions, Multiply Standard Form',
    example: '$(3 \\times 10^2) \\times (2 \\times 10^3) = 6 \\times 10^5$',
    color: '#fee2e2',
  },
  {
    name: ProcedureCategory.Derivation,
    description: 'Generate a new entity type',
    topics: 'Function → Derivative, Inverse',
    example: "$f(x) = x^2 \\Rightarrow f'(x) = 2x$",
    color: '#dbeafe',
  },
  {
    name: ProcedureCategory.Classifier,
    description: 'Classify or compare',
    topics: 'Is Convergent?, Is Prime?',
    example: '$|r| < 1 \\Rightarrow$ CONVERGENT',
    color: '#ffedd5',
  },
];

export function getProcedureCategoryInfo(category: ProcedureCategory): ProcedureCategoryInfo | undefined {
  return PROCEDURE_CATEGORIES.find((c) => c.name === category);
}

export function getProcedureCategoryColor(category: ProcedureCategory): string {
  return getProcedureCategoryInfo(category)?.color ?? '#f3f4f6';
}
